import React, { Component } from 'react'
import Sidebar from './Sidebar';
import store from '../../../store';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { Link } from 'react-router'
import { selfEmploymentSectors } from '../../../actions/accountAction'
import { getUserProfileInterest, addUserProfileInterest, getHallTicketDataList } from '../../../actions/jobseekerAction'
import SimpleReactValidator from 'simple-react-validator';


class HallTicketList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

        store.dispatch(getHallTicketDataList());
    }
    componentDidMount() {
        document.title = this.props.t('interest.title', { param: 'react' })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }





    render() {
        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }
        const Mainprops = this.props


        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="clearfix"></div>
                            <div>
                                <div className="tab-content">
                                    <div id="home" className=" tab-pane active">
                                        <section className="login-form mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-12 col-lg-12 mx-auto p-0">
                                                        <div className="panel-heading">
                                                            <h6 className="mb-0">{this.props.t("profileDetails.hallTicket.title", {
                                                                param: "react",
                                                            })}</h6>
                                                        </div>



                                                        <div className="panel-body">
                                                            <div class="table-responsive">
                                                                <table class="table table-hover table-striped">
                                                                    {this.props.JobseekerReducer.hallTicketList && this.props.JobseekerReducer.hallTicketList.length === 0 ? <div
                                                                        className="job-not-found">
                                                                        <h3>{this.props.t('JobPost.notFound', { param: 'react' })}</h3>
                                                                    </div> : <> <thead>
                                                                        <tr>
                                                                            <th>S.No</th>
                                                                            <th>Name</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                        <tbody>


                                                                            {this.props.JobseekerReducer.hallTicketList && !this.props.JobseekerReducer.hallTicketList.notFound ? this.props.JobseekerReducer.hallTicketList.map((mela, index) =>
                                                                                <tr key={mela.mela_id + "mela id"}>
                                                                                    <td>{index + 1}  </td>
                                                                                    <td>{mela.job_mela_name}</td>
                                                                                    <td> <button 
                                                                                    aria-label="View Hall Ticket"
                                                                                    type='button' onClick={() => {
                                                                                        this.props.router.push(`/hall-ticket/${mela.mela_id}`)
                                                                                    }} className='btn btn-primary2 py-1 px-2'>view</button> </td>
                                                                                </tr>) : null}

                                                                        </tbody> </>}



                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(HallTicketList));